import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { InputBaseContainer, TextAreaWithLabel } from '../../../../../molecules';
import { labels } from '../constants';
import { RootState } from '../../../../../redux/root';

const Information = ({ register, errors, setDisableSubmit }) => {
  const disabledGlobalSearch = useSelector((s: RootState) => s.inspections.disabledGlobalSearch);
  useEffect(() => {
    setDisableSubmit(!!errors.information);
  }, [errors.information]);
  return (
    <InfoWrapper>
      <InputBaseContainer>
        <TextAreaWithLabel
          showInRow
          name="information"
          error={errors.information}
          label={labels.information}
          inputRef={register}
          maxChar={2000}
          disabled={disabledGlobalSearch}
        />
      </InputBaseContainer>
    </InfoWrapper>
  );
};

export default Information;

const InfoWrapper = styled.div`
  grid-column: 1/3;
  label {
    width: 141px;
  }
`;
